import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Filelist",
  props: {
    showDownload: {
      type: Boolean,
      default: false
    },
    period: {
      type: Object
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler: function handler(value) {
        this.data = _toConsumableArray(value);
        this.getChildren();
      }
    }
  },
  data: function data() {
    return {
      records: [],
      data: []
    };
  },
  methods: {
    onDownload: function () {
      var _onDownload = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(file) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!file.file_url) {
                  _context.next = 4;
                  break;
                }

                window.open(file.file_url);
                _context.next = 6;
                break;

              case 4:
                _context.next = 6;
                return this.$error("没有文件可下载");

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDownload(_x) {
        return _onDownload.apply(this, arguments);
      }

      return onDownload;
    }(),
    // async onDownload(item) {
    //   let data = await this.$http.get(
    //     `/api/app/periods/datum/download/${item.datum_id}`,
    //   );
    //   if (data.file_url) {
    //     this.$pub.downloadFile(data.file_url, item.ware_filename);
    //   } else {
    //     await this.$error("没有文件可下载");
    //   }
    // },
    getChildren: function getChildren() {
      this.data.forEach(function (f) {
        if (/\.(wma|mp4|aac|flac|m4a|oga|opus|3gp|mpg|mpeg|3g2|avi|flv|h264|m4v|mj2|mov|ogg|ogv|rm|rmvb|qt|webm)$/i.test(f.ware_filename)) {
          f.type = "video";
        } else if (/\.(doc|docx)$/i.test(f.ware_filename)) {
          f.type = "word";
        } else if (/\.(jpg|png|gif|jpeg|bmp)$/i.test(f.ware_filename)) {
          f.type = "img";
        } else if (/\.(xls|xlsx)$/i.test(f.ware_filename)) {
          f.type = "excel";
        } else if (/\.(pdf)$/i.test(f.ware_filename)) {
          f.type = "pdf";
        } else if (/\.(ppt|pptx)$/i.test(f.ware_filename)) {
          f.type = "ppt";
        } else if (/\.(zip)$/i.test(f.ware_filename)) {
          f.type = "zip";
        } else if (/\.(mp3|wav|wmv)$/i.test(f.ware_filename)) {
          f.type = "audio";
        } else {
          f.type = "file";
        }
      });
    },
    onFileClick: function onFileClick(file) {
      if (!file.ware_url) {
        return;
      }

      window.open(file.ware_url);
    },
    onPreview: function () {
      var _onPreview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(file) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.open(file.file_url); // if (file.type == "video" || file.type == "audio") {
                //   let data = await this.$http.get(
                //     "/api/app/user/CourseWare/video/preview",
                //     {
                //       video_id: file.fid,
                //     },
                //   );
                //   window.open(data[0].url);
                // } else {
                //   let data = await this.$http.get("/api/app/user/CourseWare/preview", {
                //     fid: file.fid,
                //   });
                //   window.open(data);
                // }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onPreview(_x2) {
        return _onPreview.apply(this, arguments);
      }

      return onPreview;
    }()
  }
};